module.exports = __webpack_public_path__ + "static/media/alien-monster.fe7d38c3.svg";